import React from "react";
import { Table } from "reactstrap";
import DoneIcon from "@mui/icons-material/Done";

const QualityParamsModal = ({ qualityParams }) => {
  console.log("qualityParams",qualityParams)
  return (
    <div>
      {qualityParams?.parameters?.length > 0 ? (
        <Table striped hover className="">
          <thead>
            <tr>
              <th className="th-sm">Parameter</th>
              <th className="th-sm">Selected Values</th>
              <th className="th-sm">Reference Values</th>
            </tr>
          </thead>
          <tbody>
            {qualityParams?.parameters?.map((field, index) => (
              <tr key={index}>
                <td>{field.fields}</td>
                {/* <td>
                  {Object.entries(field.range).map(([key, value]) => (
                    <div key={key}>
                      {value} <DoneIcon className="f300 steelblue" />
                    </div>
                  ))}
                </td> */}
             <td>
  {(() => {
    if (field?.range?.edited_key && field?.range?.edited_key !== "") {
      return (
        <div key="edited_key">
          {field?.range?.edited_key} <DoneIcon className="f300 steelblue" />
        </div>
      );
    }

    // Find the first available key that is not edited_key
    const otherKey = field?.range 
    ? Object.entries(field.range).find(([key]) => key !== "edited_key") 
    : undefined;    
    return otherKey ? (
      <div key={otherKey[0]}>
        {otherKey[1]} <DoneIcon className="f300 steelblue" />
      </div>
    ) : null;
  })()}
</td>




                <td>
                  {field.reference_keys &&
                    Object.entries(field.reference_keys).map(([key, value]) => (
                      <li key={key} className="mt-1 text-gray">
                        {value}
                      </li>
                    ))}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      ) : (
        <div className="text-center mt-2">No Data Found</div>
      )}
    </div>
  );
};

export default QualityParamsModal;
